import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DefaultLayout from './components/templates/DefaultLayout';
import Home from './components/pages/Home';
import Coupon from './components/pages/Coupon';
import CouponNew from './components/pages/CouponNew';
import CouponEdit from './components/pages/CouponEdit';
import Info from './components/pages/Info';
import Topic from './components/pages/Topic';
import { fetchCoupons } from "./stores/slices/couponSlice";
import { fetchInfos } from "./stores/slices/infoSlice";
import { fetchTopics } from "./stores/slices/topicSlice";
import { AppDispatch } from "./stores/store";
import { Amplify } from 'aws-amplify';
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import Login from './auth/components/pages/Login';
import ResetPw from './auth/components/pages/ResetPw';
import ResetPwInputCode from './auth/components/pages/ResetPwInputCode';
import LoginLayout from './auth/components/templates/LoginLayout';
import "./styles/reset.css";
import InfoNew from "./components/pages/InfoNew";
import InfoEdit from "./components/pages/InfoEdit";
import TopicNew from "./components/pages/TopicNew";
import TopicEdit from "./components/pages/TopicEdit";
import User from "./components/pages/User";
import Point from "./components/pages/Point";
import Advertisement from "./components/pages/Advertisement";
import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';

function App() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
        userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID as string,
      },
    },
  });
  
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchCoupons());
    dispatch(fetchInfos());
    dispatch(fetchTopics());
  }, [dispatch]);

  const cookieStorage = new CookieStorage({
    secure: true,
    sameSite: 'strict',
  });

  cognitoUserPoolsTokenProvider.setKeyValueStorage(cookieStorage);

  return (
    <BrowserRouter>
      <Routes>
        
        <Route element={<PublicRoute><LoginLayout /></PublicRoute>}>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-pw" element={<ResetPw />} />
          <Route path="/reset-pw-input-code" element={<ResetPwInputCode />} />
        </Route>

        <Route element={<PrivateRoute><DefaultLayout /></PrivateRoute>}>
          <Route path="/" element={<Home />} />
          <Route path='/coupon' element={<Coupon />} />
          <Route path="/coupon/new" element={<CouponNew />} />
          <Route path="/coupon/edit/:id" element={<CouponEdit />} />
          <Route path='/info' element={<Info />} />
          <Route path='/info/new' element={<InfoNew />} />
          <Route path='/info/edit/:id' element={<InfoEdit />} />
          <Route path='/topic' element={<Topic />} />
          <Route path='/topic/new' element={<TopicNew />} />
          <Route path='/topic/edit/:id' element={<TopicEdit />} />
          <Route path="/user" element={<User />} />
          <Route path="/point" element={<Point />} />
          <Route path="/advertisement" element={<Advertisement />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
